// @ts-nocheck
import { createAction } from "@reduxjs/toolkit";

export const logoutAction = createAction("common/logout");

export const refreshAction = createAction("common/refresh");

export const hashFineractPublicAuthorizationAction = createAction(
  "common/hashFineractPublicAuthorization"
);
